import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

type CheckBoxProps = {
  borderRadius?: string
  checked: boolean
  size?: string
  uncheckedBg?: string
}

const CheckboxWrapper = styled.div<{ checked: boolean; size?: string }>`
  input[type='checkbox'] + label::after {
    content: ${(p) => (p.checked ? '' : 'none')};
  }
  width: ${({ size }) => size || '24px'};
  height: ${({ size }) => size || '24px'};
  position: relative;
`

const Checkbox = styled.input`
  opacity: 0;
`

const CheckboxLabel = styled.label<{
  borderRadius?: string
  checked?: boolean
  size?: string
  uncheckedBg?: string
}>`
  position: relative;

  &:before {
    content: '';
    display: inline-block;
    height: ${({ size }) => size || '24px'};
    width: ${({ size }) => size || '24px'};
    background: ${({ checked, uncheckedBg }) =>
      checked ? color('blue600') : uncheckedBg ? color(uncheckedBg) : color('dark800')};
    border: 1px solid
      ${({ checked, uncheckedBg }) =>
        checked ? color('blue600') : uncheckedBg ? color(uncheckedBg) : color('dark600')};
    border-radius: ${({ borderRadius }) => borderRadius || '8px'};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &:after {
    content: '';
    display: inline-block;
    height: 6px;
    width: 13px;
    border-left: 2px solid;
    border-bottom: 2px solid;
    transform: rotate(-45deg);
    left: -6px;
    top: 6px;
    color: ${color('white')};
  }

  &:after,
  &:before {
    position: absolute;
  }
`

const CheckBox = ({ borderRadius, checked, size, uncheckedBg }: CheckBoxProps) => (
  <CheckboxWrapper size={size} checked={checked}>
    <Checkbox defaultChecked={checked} type='checkbox' />
    <CheckboxLabel
      size={size}
      uncheckedBg={uncheckedBg}
      checked={checked}
      borderRadius={borderRadius}
    />
  </CheckboxWrapper>
)

export default CheckBox
